import { MutationCache, QueryClient } from '@tanstack/react-query';

/** Global event channel for app-level toasts raised from outside React (here,
 * the shared mutation onError). A single listener in the /app shell renders
 * them — pages keep their own local toasts. */
const APP_TOAST_EVENT = 'ao:app-toast';


function emitAppToast(message, variant = 'danger') {
  if (typeof window === 'undefined') {
    return;
  }
  window.dispatchEvent(new CustomEvent(APP_TOAST_EVENT, { detail: { message, variant } }));
}


/** Shared mutation error surface, raised once from the cache rather than per call:
 *  - Soft-wall (#162): 403 `subscription_locked` → upgrade prompt, always — it's
 *    the canonical message and pages don't carry their own locked copy.
 *
 * The generic permission toast (#206) lives in useBaseMutation instead: the
 * cache cannot see `mutate(vars, { onError })` call-site handlers, so deciding
 * "is anyone handling this?" here would double-toast half the app. The wrapper
 * sees both levels and attaches the fallback only when nobody else handles it. */
const mutationCache = new MutationCache({
  onError: (error) => {
    const response = error?.response;
    if (response?.status === 403 && response?.data?.code === 'subscription_locked') {
      emitAppToast('Your subscription is locked — upgrade to make changes.');
    }
  },
});

const queryClient = new QueryClient({ mutationCache });

export { APP_TOAST_EVENT, emitAppToast, queryClient };
export default queryClient;
